import { troubleshootingHoldOption } from '@constants/troubleshootingHoldOption';

export const getAIStatusesList = (t) => [
  { value: 'all', label: t('All') },
  { value: '0', label: t('New') },
  { value: '10', label: t('Needs Response') },
  { value: '2', label: t('Waiting') },
  { value: '3', label: t('Snoozed') },
  { value: '6', label: t('Verifying') },
  { value: troubleshootingHoldOption.id, label: t(troubleshootingHoldOption.name) },
];
